export default "__VITE_ASSET__DYDPzicw__"